import { memo } from "react";
import Link from "next/link";

import Item from "./Item";

function CartParcelItems(props) {
  const { styles, address, dispatch, index, data, setPromo, promo } = props;
  return (
    <div className="col-md-12 col-lg-6">
      <div className={styles.bagsItemOuter}>
        <span className={styles.bagsHd}>
          Parcel {index + 1} - Sent by{" "}
          <Link href={`/stores/${data.shop_url}`}>{data.shop_name}</Link>
        </span>
        {!!promo?.length && (
          <div className={styles.promoCode}>
            Promo Code(s) Available:{" "}
            <a
              onClick={() =>
                setPromo({
                  productIds: data.products.map((i) => i.product_id),
                  retailerId: data.id,
                })
              }
            >
              Click here
            </a>
          </div>
        )}
        {data.products.map((item, key) => (
          <Item
            key={`cartparcelitems-${key}-${new Date().toISOString()}`}
            item={item}
            styles={styles}
            address={address}
            dispatch={dispatch}
          />
        ))}
      </div>
    </div>
  );
}

export default memo(CartParcelItems);
